import React from 'react';
import translate from '../../i18n/translate';

/**
 * Vision — three DVBC conditions (a) settlement, (b) linkage, (c) governance.
 * Status badges reflect Sepolia deployment reality:
 *   (a) Phase 2 — pending governance vote
 *   (b) Live — MethaCrowdsale.weiRaisedPerPeriod is on-chain
 *   (c) Live — OpenGovernance is on-chain
 */
export default function Vision() {
  return (
    <section className="lv2-section" id="vision">
      <div className="lv2-shell">
        <div className="lv2-section-head">
          <span className="lv2-section-tag">{translate('lv2-vision-tag')}</span>
          <h2>{translate('lv2-vision-h2')}</h2>
          <p className="sub">{translate('lv2-vision-sub')}</p>
        </div>

        <div className="lv2-vision-grid">
          <article className="lv2-vision-card">
            <svg className="lv2-vision-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
              <circle cx="12" cy="12" r="9"/>
              <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/>
            </svg>
            <span className="lv2-vision-cond">{translate('lv2-vision-a-label')}</span>
            <h3>{translate('lv2-vision-a-h3')}</h3>
            <p>{translate('lv2-vision-a-p')}</p>
            <div className="lv2-vision-status">
              <span className="pending">●</span> {translate('lv2-vision-status-pending')}
            </div>
          </article>

          <article className="lv2-vision-card">
            <svg className="lv2-vision-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
              <path d="M3 17l4-4 4 4 4-7 6 7"/>
              <circle cx="3" cy="17" r="1.5"/>
              <circle cx="7" cy="13" r="1.5"/>
              <circle cx="11" cy="17" r="1.5"/>
              <circle cx="15" cy="10" r="1.5"/>
              <circle cx="21" cy="17" r="1.5"/>
            </svg>
            <span className="lv2-vision-cond">{translate('lv2-vision-b-label')}</span>
            <h3>{translate('lv2-vision-b-h3')}</h3>
            <p>{translate('lv2-vision-b-p')}</p>
            <div className="lv2-vision-status">
              <span className="live">●</span> {translate('lv2-vision-status-live')}
            </div>
          </article>

          <article className="lv2-vision-card">
            <svg className="lv2-vision-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
              <circle cx="12" cy="8" r="3"/>
              <circle cx="6" cy="17" r="3"/>
              <circle cx="18" cy="17" r="3"/>
              <path d="M9.5 9.5L7.5 14.5M14.5 9.5L16.5 14.5M9 17h6"/>
            </svg>
            <span className="lv2-vision-cond">{translate('lv2-vision-c-label')}</span>
            <h3>{translate('lv2-vision-c-h3')}</h3>
            <p>{translate('lv2-vision-c-p')}</p>
            <div className="lv2-vision-status">
              <span className="live">●</span> {translate('lv2-vision-status-live')}
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
